import { apiClient } from '../../services/api';
import { createClientRequestId } from '../../utils/clientRequestId';

const HEADERS = { 'X-Portal': 'business' };
const unwrap = response => response?.data?.data ?? response?.data ?? response;

export const businessFulfillmentService = Object.freeze({
  async list(params = {}, signal) {
    return unwrap(await apiClient.get('/api/business/orders/fulfillment', {
      headers: HEADERS, params, signal,
    }));
  },
  async detail(orderId, signal) {
    return unwrap(await apiClient.get(`/api/business/orders/${orderId}/fulfillment`, {
      headers: HEADERS, signal,
    }));
  },
  async saveChecklist(orderId, items) {
    return unwrap(await apiClient.put(
      `/api/business/delivery/orders/${orderId}/fulfillment/checklist`,
      { items },
      { headers: HEADERS },
    ));
  },
  async transition(orderId, command, expectedVersion) {
    const durable = ['ready-for-dispatch', 'cancel-before-pickup'].includes(command);
    return unwrap(await apiClient.post(
      `/api/business/delivery/orders/${orderId}/fulfillment/${command}`,
      { expectedVersion },
      { headers: {
        ...HEADERS,
        ...(durable ? { 'Idempotency-Key': createClientRequestId(`fulfillment_${command}`) } : {}),
      } },
    ));
  },
  async parcelCommand(businessId, shipmentId, command, payload = {}) {
    const paths = {
      ISSUE: 'parcel-labels/issue',
      CONFIRM_ATTACHED: 'parcel-labels/confirm-attached',
      REPRINT: 'parcel-labels/reprint',
      REPLACE: 'parcel-labels/replace',
    };
    const path = paths[command];
    if (!path) throw new Error('Unsupported Parcel command');
    return unwrap(await apiClient.post(
      `/api/business/delivery/shipments/${shipmentId}/${path}`,
      { businessId, ...payload },
      { headers: {
        ...HEADERS,
        'Idempotency-Key': createClientRequestId(`parcel_${command.toLowerCase()}`),
      } },
    ));
  },
});
